import { render } from "./UserManagementDetail.vue?vue&type=template&id=0fe890a4&scoped=true"
import script from "./UserManagementDetail.vue?vue&type=script&lang=js"
export * from "./UserManagementDetail.vue?vue&type=script&lang=js"

import "./UserManagementDetail.vue?vue&type=style&index=0&id=0fe890a4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0fe890a4"]])

export default __exports__